import { useEffect } from "react";

export interface IProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  uri?: string;
}

const useImg = (props: IProps) => {
  useEffect(() => {
    props.setLoading(false);
  }, [props]);

  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useImg>;

export default useImg;
